import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  createPresentationAudienceLatency: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation-audience-latency/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createPresentationAudienceLatency = async (payload) => {
  return resource.createPresentationAudienceLatency(payload)
}

export default {
  initResource,
  createPresentationAudienceLatency,
}
